// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class CustomerServiceProviderRecord extends VerofreshRecord {
}

export default CustomerServiceProviderRecord
